<!-- <div class="overlay">
  <img src="assets/img/loading3.gif" class="imagem">
</div> -->

<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{"Utilize o novo termômetro para aumentar ou reduzir sua comissão" |
        translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="fecharModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>



<div class="modal-body">
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-md-10">
                    <h4 style="font-family: var(--TextoTitulo) !important">Comissão por item</h4>
                </div>
                <div class="col-md-2" style="text-align: right">
                    <a href="javascript:void(0)" [hidden]="!toggleComissoes"
                        (click)="toggleComissoes = !toggleComissoes"><i class="fa CorSecundaria fa-minus"
                            aria-hidden="true"> </i> </a>
                    <a href="javascript:void(0)" [hidden]="toggleComissoes"
                        (click)="toggleComissoes = !toggleComissoes"><i class="fa CorSecundaria fa-plus"
                            aria-hidden="true"></i> </a>
                </div>
            </div>
        </div>
        <div class="card-body pl-0" [hidden]="!toggleComissoes">

            <div class="row mobile-gap">
                <div class="col-md-12" style="display: inline-grid;">
                    <span *ngFor="let c of comissoes" style="margin-left: 1.33em;">
                        {{c}}
                    </span>
                </div>
            </div>

        </div>
    </div>

    <div class="card">
        <div class="card-body pl-0">
            <div class="row mobile-gap">
                <div class="col-md-3" style="display: inline-grid;text-align: -webkit-right;">
                    <span>{{"Comissão + Extra" | translate}}</span>
                    <span style="align-self: center;">{{"Comissão Padrão" | translate}}</span>
                    <span style="align-self: end;">{{"Comissão = 0" | translate}}</span>
                </div>
                <div class="col-md-3" style="height: 300px;" *ngIf="!buscandoTermometro">
                    <ngx-slider [(value)]="value" [options]="options"></ngx-slider>
                </div>
                <div class="col-md-6 align-self-center">
                    <input [required]="true"  [(ngModel)]="value" class="form-control" currencyMask />
                    <div class="">
                        <label class="form-check-label" for="Ciente"></label>
                        <input type="checkbox" id="Ciente" name="Ciente" [(ngModel)]="Ciente" />
                        {{'Estou ciente e de acordo que será deduzido 15% de taxas financeiras sobre o valor da comissão extra (aplicada somente para o adicional cobrado).' | translate}}
                    </div>
                    <button class="btn btn-success" type="submit" (click)="alterar()" [disabled]="!Ciente">{{ 'Alterar'
                        | translate}}</button>
                    <button class="btn btn-danger mt-3 mb-3" (click)="value = comissao">{{ 'Voltar Comissão Padrão' |
                        translate}}</button>
                    <!-- <button class="btn btn-cancelar" (click)="fecharModal()">{{ 'Fechar' | translate}}</button> -->
                </div>
            </div>
        </div>
    </div>

</div>
